import { GridColDef } from "@mui/x-data-grid";

/**
 * Column definitions for the products data grid
 * 
 * Defines the structure and properties of columns displayed in the products table.
 * Each column specifies the field to display, header text, and layout properties.
 *
 * @type {GridColDef[]} Array of column definition objects
 * 
 * @property {string} name.field - Field name for the product name column
 * @property {string} name.headerName - Display name for the product name column
 * @property {number} name.flex - Flex grow factor for the name column width
 * 
 * @property {string} productType.field - Field name for the product type column
 * @property {string} productType.headerName - Display name for the product type column 
 * @property {number} productType.flex - Flex grow factor for the product type column width
 */
export const columns: GridColDef[] = [
  {
    field: "name",
    headerName: "Name",
    flex: 1,
  },
  {
    field: "productType",
    headerName: "Produkttyp",
    flex: 1,
  },
];
